var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"error-page"},[_c('div',[_c('h1',{staticClass:"error-page__big-title"},[_vm._v(" "+_vm._s(_vm.statusCode)+" ")]),_c('h3',{staticClass:"error-page__sub-title"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])]),_c('Footer'),_c('AppAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }